import React, { useEffect, useState } from 'react';

import { useLocale, useTranslations } from 'next-intl';
import styled from 'styled-components';

import { Format } from '@/lib/dateTime/formatDate';
import { log } from '@/utils/logger';

const Time = styled.time`
  color: #000;
  font-family: 'Atlas Grotesk';
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
`;

export default function RelativeDate({ date: dateString, dateOnly = false }) {
  const locale = useLocale();
  const t = useTranslations();
  const [relativeDate, setRelativeDate] = useState<string>('');
  const [dateIsoString, setDateIsoString] = useState<string>('');

  useEffect(() => {
    const date = new Format(dateString);
    const relativeLocaleDate = date.in(locale).toRelativeTime();
    setRelativeDate(relativeLocaleDate);
  }, [relativeDate]);

  useEffect(() => {
    const date = new Format(dateString);
    const dateIsoLocaleString = date.toIsoString();
    setDateIsoString(dateIsoLocaleString);
  }, [dateIsoString]);

  if (!dateString) {
    log.error('RelativeDate: date is missing');
    return null;
  }

  if (dateOnly) {
    return <Time dateTime={dateIsoString}>{relativeDate}</Time>;
  }

  return (
    <Time dateTime={dateIsoString}>
      {t('last-updated')} {relativeDate}
    </Time>
  );
}
